document.addEventListener('DOMContentLoaded', function () {
    const buttonsContainer = document.querySelector('.container_contact');

    if (!buttonsContainer){
        return;
    }

    const forms = document.querySelectorAll('.container_contact .container_form');
    const decisiongroups = document.querySelectorAll('.container_contact .decision-group');


    const contactForms = buttonsContainer.querySelectorAll('.container_form');

    contactForms.forEach(form=> {
        const errorClass = form.querySelector('.has-error');
        if (errorClass) {
            form.classList.remove('d-none');
            form.classList.add('d-block');
            form.closest('.decision-group').classList.add('d-block');
        }
    });

    function adjustId(id) {
        if (!document.getElementById(id)) {
            return id.replace(/form-(\d+)-\d+$/, 'decision-group-$1');
        }
        return id;
    }

    function showParentGroups(element) {
        while (element && !element.classList.contains('container_contact')) {
            if (element.classList.contains('decision-group')) {
                // element.style.display = 'block';
                element.classList.remove('d-none');
                element.classList.add('d-block');
            }
            element = element.parentElement;
        }
    }

    // Überprüfen, ob es mindestens ein Element gibt, um Fehler zu vermeiden
    if (decisiongroups.length > 0) {
        // erste Entscheidungsgruppe aktivieren
        // decisiongroups[0].style.display = 'block';
        decisiongroups[0].classList.remove('d-none');
        decisiongroups[0].classList.add('d-block');
    }

    // Event-Delegation: Anstatt auf jeden Button separat einen Listener zu setzen,
    // setzen wir einen Listener auf den Container für die Buttons.
    if(buttonsContainer){
        buttonsContainer.addEventListener('click', function (event) {
            const button = event.target.closest('.js-form-toggle');
            if (!button) return; // Klick war nicht auf einen relevanten Button

            const formId = button.getAttribute('data-form-id');

            // Alle Formulare ausblenden
            forms.forEach(form => {
                form.classList.remove('d-block');
                form.classList.add('d-none');
            });

            // Alle Entscheidungsgruppen ausblenden außer der ersten
            decisiongroups.forEach((group, index) => {
                if (index !== 0) {
                    group.classList.remove('d-block');
                    group.classList.add('d-none');
                }
            });

            // Das ausgewählte Formular oder die Entscheidungsgruppe einblenden
            const activeFormOrDecision = document.getElementById(adjustId(formId));
            if (activeFormOrDecision) {
                //activeFormOrDecision.style.display = 'block';
                activeFormOrDecision.classList.remove('d-none');
                activeFormOrDecision.classList.add('d-block');
                showParentGroups(activeFormOrDecision);
            }

            // Button-Stile aktualisieren
            buttonsContainer.querySelectorAll('.js-form-toggle').forEach(btn => {
                btn.classList.remove('btn-secondary', 'active');
                btn.classList.remove('btn-secondary');
            });
            button.classList.remove('btn-outline-secondary');
            button.classList.add('btn-secondary', 'active');
        });
    }
});
